import Collection from "../../valueObject/Collection";
import IFrameMessage from "../IFrameMessage";

export default class OpenCTAMessage extends IFrameMessage {
    public static ACTION_NAME = "open-cta";
    constructor() {
        super(OpenCTAMessage.ACTION_NAME);
    }

    public send() {
        super._send(new Collection({}));
    }

    public recieve(callback: Function) {
        callback();
    }
}
